import styled from 'styled-components';
import { colors } from 'constants/colors';
import { styleSizes } from "constants/styleSizes";


export const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  height: 56px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.black};
  z-index: 1000;
  
  .innerContainer {
    position: absolute;
    width: 100%;
    max-width: 1229px;
    padding: 0 32px;
    display: flex;
    align-items: center;
    line-height: 56px;
    justify-content: space-between;

    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      padding: 0 32px;
      min-width: 320px;
    }
  }

  .navTitle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .HeaderContent {
    display: flex;
    justify-content: right;
    gap: 32px;
    .HeaderLink {
      font-size: 16px;
      font-weight: bold;
      color: ${colors.white};
      
      cursor: pointer;
      text-decoration: none;
      display: flex;
      flex-direction: row;
      gap: 8px;
      align-items: center;
      @media (max-width: ${styleSizes.miniBreakpoint}) {
        font-size: 14px; 
    }
    }
    .MobileHeaderLink {
       background-color:  ${colors.iconBlue};
       width: 32px;
       height: 32px;
       border-radius: 16px;
       margin-top: 0;
       margin-right: 0;
       justify-content: center;
       
    }
  }

  .MobileHeaderContent {
    display: none;
    flex-direction: row;
    gap: 12px;
    align-items: center;
  }

  .Header {
    height: 44px;
    min-width: 60px;
    border-radius: 22px;
    box-sizing: border-box;
    padding: 0 16px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: ${colors.menuGrey};
  }

.controlButtons {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

/* .addGuestInfoButton {
  display: none;
  @media (max-width: ${styleSizes.tabletBreakpoint}) {
    display: block;
  }

}

.bookNowButton {
  display: none;
  @media (max-width: ${styleSizes.tabletBreakpoint}) {
    display: block;
    }
} */

  .hotelLogo {
    width: 162px;
    height: 44px;
    @media (max-width: ${styleSizes.mobileBreakpoint}) {
      width: 111px;
      height: 31px;
    }
  }

  .menuContainer {
    position: absolute;
    top: 6px;
    right: 31px;
    width: 93px;
    height: 44px;
  }

  @media only screen and (max-width: 652px) {
    .HeaderContent {
      display: none;
    }
    .MobileHeaderContent {
      display: flex;
    }
  }
`;

type HotelTitleProps = {
  fontSize?: number;
};

export const HotelTitle = styled.div<HotelTitleProps>`
  display: flex;
  font-size: ${(props) => (props.fontSize? `${props.fontSize}px` : '22px')};
  font-weight: 300;
  color: ${colors.white};
  text-align: center;
  cursor: pointer;
  span {
    font-weight: 600;
    margin-right: 5px;
    margin-left: 5px;
  }
`;